/**
 * 发货类型(1:大件普通 0:大件fba 2:小件  3:次品退货 4:异常退货 5:仓库调拨)
 * **/
 export const deliveryTypes = {
    // FBA发货
    "largeBag": 1,
    "FBA": 0,
    "smallBag": 2,

}

/**
 * 发货状态(0:待处理 1:拣货中 2:打标中 3:打包中 4:打包完成 5:已发货)
 * **/
export const processingStatusList = {
    "ToBeProcessed": 0,
    "ToBeConfirm": 1,
    "Completed": 2,
    "warning": 3
}